import AddNewTrunkForm, {
  IAddNewTrunkFormProps,
} from "../../../../../forms/add-new-trunk/AddNewTrunkForm";
import MuiBaseModal from "../../../../common/modal/MuiModal";

export interface IAddNewTrunkProps extends IAddNewTrunkFormProps {
  openModal: boolean;
}

export default function AddNewTrunkModal({
  handleReload,
  onClose,
  openModal,
  serverInfo,
}: Readonly<IAddNewTrunkProps>) {
  return (
    <MuiBaseModal
      onClose={onClose}
      open={openModal}
      title={"افزودن/آپدیت ترانک"}
      subTitle={"جهت افزودن/آپدیت ترانک فیلد هارو کامل کنید"}
      hasCloseIcon
    >
      <AddNewTrunkForm
        handleReload={handleReload}
        onClose={onClose}
        serverInfo={serverInfo}
      />
    </MuiBaseModal>
  );
}
